import { useCallback, useState } from "react";
import "@/App.css";
import "@/styles/branding-overrides.css";
import "@/lib/killEmergentBadge";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Navigation from "@/components/maison/Navigation";
import HeroSection from "@/components/maison/HeroSection";
import FalconHeartSection from "@/components/maison/FalconHeartSection";
import AviationSection from "@/components/maison/AviationSection";
import CraftsmanshipSection from "@/components/maison/CraftsmanshipSection";
import MonacoSection from "@/components/maison/MonacoSection";
import PrivateAcquisitionsSection from "@/components/maison/PrivateAcquisitionsSection";
import DiamondsSection from "@/components/maison/DiamondsSection";
import HeritageSection from "@/components/maison/HeritageSection";
import InvitationSection from "@/components/maison/InvitationSection";
import Footer from "@/components/maison/Footer";
import PrivateInquiryDialog from "@/components/maison/PrivateInquiryDialog";
import UltraFineJewelryPage from "@/pages/UltraFineJewelryPage";
import JewelryPiecePage from "@/pages/JewelryPiecePage";
import PaymentResultPage from "@/pages/PaymentResultPage";

function scrollToId(id) {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
}

const Home = () => {
  const [dialog, setDialog] = useState({ open: false, type: "viewing", piece: null });

  const openDialog = useCallback((type, piece = null) => {
    setDialog({ open: true, type, piece });
  }, []);
  const closeDialog = useCallback(() => setDialog((d) => ({ ...d, open: false })), []);

  return (
    <div className="bg-black text-white" data-testid="home-page">
      <Navigation />
      <HeroSection
        onRequestViewing={() => openDialog("viewing", "The Falcon Heart")}
        onDiscover={() => scrollToId("falcon-heart")}
      />
      <FalconHeartSection onRequest={() => openDialog("pricing", "The Falcon Heart")} />
      <AviationSection onRequest={() => openDialog("appointment", "PiérrecDavís Private Aviation")} />
      <CraftsmanshipSection />
      <MonacoSection onRequest={() => scrollToId("invitation")} />
      <PrivateAcquisitionsSection onSelect={(type) => openDialog(type)} />
      <DiamondsSection onRequest={() => openDialog("pricing", "PiérrecDavís Diamonds")} />
      <HeritageSection onRequest={() => openDialog("appointment", "Élysée Open-Heart Automatic")} />
      <InvitationSection />
      <Footer />

      <PrivateInquiryDialog
        open={dialog.open}
        type={dialog.type}
        piece={dialog.piece}
        onClose={closeDialog}
      />
    </div>
  );
};

function App() {
  return (
    <div className="App bg-black text-white min-h-screen">
      <Toaster
        position="top-center"
        theme="dark"
        toastOptions={{
          style: {
            background: "#0a0a0a",
            color: "#fff",
            border: "1px solid rgba(212,175,140,0.35)",
            borderRadius: 0,
            fontFamily: "Outfit, sans-serif",
            letterSpacing: "0.04em",
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/ultra-fine-jewelry" element={<UltraFineJewelryPage />} />
          <Route path="/ultra-fine-jewelry/:slug" element={<JewelryPiecePage />} />
          <Route path="/payment/success" element={<PaymentResultPage />} />
          <Route path="/payment/cancel" element={<PaymentResultPage cancelled />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
